module.exports = __webpack_public_path__ + "static/gang-leader-for-a-day-5579fe8529dd6f710c039264554dfeaa.jpg";